export const IS_TRIAL_USER = 'isTrialUser';
export const TRIAL_LINK_FROM = 'trialLinkFrom';
